import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssessContributionToCostsComponent } from './apportionment/assess-contribution-to-costs/assess-contribution-to-costs.component';
import { NihlRoutingModule } from './nihl-routing.module';
import { OutlineExposureComponent } from './investigation/outline-exposure/outline-exposure.component';
import { KButtonModule } from 'ng-k-button';
import { KIconModule } from 'ng-k-icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KFormModule } from 'ng-k-form';
import { AudiometryFormComponent } from './investigation/audiometry-form/audiometry-form.component';
import { KCardModule } from 'ng-k-card';
import { KNotificationsModule } from 'ng-k-notifications';
import { AudiogramAnalyseComponent } from './investigation/audiogram-analyse/audiogram-analyse.component';
import { FilterComponent } from './investigation/audiogram-analyse/filter/filter.component';
import { ModifierComponent } from './investigation/audiogram-analyse/modifier/modifier.component';
import { TableComponent } from './investigation/audiogram-analyse/table/table.component';
import { FormComponent } from './investigation/audiogram-analyse/modifier/form/form.component';
import { ChartComponent } from './investigation/audiogram-analyse/chart/chart.component';
import { OutlineExposureListingComponent } from './investigation/outline-exposure-listing/outline-exposure-listing.component';
import { KDataVisualizationModule } from 'ng-k-data-visualization';
import { NgChartsModule } from 'ng2-charts';
import { KTabsModule } from 'ng-k-tabs';
import { AudiogramCompareComponent } from './investigation/audiogram-compare/audiogram-compare.component';
import { Form2Component } from './investigation/audiogram-analyse/modifier/form2/form2.component';
import { CustomBreadcrumbModule } from '../common/custom-breadcrumb/custom-breadcrumb.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpReqInterceptor } from 'src/app/interceptors/http-req.interceptor';

@NgModule({
  declarations: [
    AssessContributionToCostsComponent,
    OutlineExposureComponent,
    AudiometryFormComponent,
    AudiogramAnalyseComponent,
    FilterComponent,
    ModifierComponent,
    TableComponent,
    FormComponent,
    ChartComponent,
    OutlineExposureListingComponent,
    AudiogramCompareComponent,
    Form2Component,
  ],
  imports: [
    CommonModule,
    NihlRoutingModule,
    KButtonModule,
    KIconModule,
    FormsModule,
    ReactiveFormsModule,
    KFormModule,
    KCardModule,
    KNotificationsModule,
    NgChartsModule,
    KTabsModule,
    KDataVisualizationModule,
    CustomBreadcrumbModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpReqInterceptor,
      multi: true,
    },
  ]
})
export class NihlModule { }
